module.exports = __webpack_public_path__ + "img/zoom-in.8d636a54.svg";